var map = {
	"./arrow-down-circle.svg": 31,
	"./arrow-down-left.svg": 32,
	"./arrow-down-right.svg": 33,
	"./arrow-down.svg": 34,
	"./arrow-left-circle.svg": 35,
	"./arrow-left.svg": 36,
	"./arrow-right-circle.svg": 37,
	"./arrow-right.svg": 38,
	"./arrow-up-circle.svg": 39,
	"./arrow-up-left.svg": 40,
	"./arrow-up-right.svg": 41,
	"./arrow-up.svg": 42,
	"./at-sign.svg": 43,
	"./chevron-down.svg": 44,
	"./chevron-left.svg": 45,
	"./chevron-right.svg": 46,
	"./chevron-up.svg": 47,
	"./chevrons-down.svg": 48,
	"./chevrons-left.svg": 49,
	"./chevrons-right.svg": 50,
	"./chevrons-up.svg": 51,
	"./download.svg": 52,
	"./edit.svg": 53,
	"./external-link.svg": 54,
	"./eye.svg": 55,
	"./facebook.svg": 56,
	"./instagram.svg": 57,
	"./link-2.svg": 58,
	"./link.svg": 59,
	"./linkedin.svg": 60,
	"./list.svg": 61,
	"./loader.svg": 62,
	"./lock.svg": 63,
	"./log-in.svg": 64,
	"./log-out.svg": 65,
	"./mail.svg": 66,
	"./map-pin.svg": 67,
	"./maximize.svg": 68,
	"./menu.svg": 69,
	"./search.svg": 70,
	"./twitter.svg": 71,
	"./x.svg": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;


//////////////////
// WEBPACK FOOTER
// ./src/icons \.svg
// module id = 30
// module chunks = 0